import React from 'react';
import { Card } from 'react-bootstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const CardSkeleton = () => {
  return (
    <SkeletonTheme baseColor="#f7f4f2" highlightColor="#f9f9f8" borderRadius={0}>
      <div className="col-6 col-md-3">
        <Card className="shadow border-0">
          <Skeleton height={265} className="d-flex mt-n1" />
          <Card.Body className="flex-column d-flex">
            <div className="flex-1">
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </div>
          </Card.Body>
        </Card>
      </div>
    </SkeletonTheme>
  );
};

const EventTileSkeleton = () => {
  return (
    <>
      <p aria-live="polite" className="visually-hidden">
        Events are loading
      </p>
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
    </>
  );
};

export default EventTileSkeleton;
